import { useTranslation } from 'react-i18next';

export function HiddenArbeitsbereich() {
  const { t } = useTranslation();
  return (
    <div className="text-xs">{t('domain.termine.hiddenArbeitsbereich')}</div>
  );
}
